import { useContext, useEffect, useState } from 'react';
import Moment from 'react-moment';
import { useDispatch, useSelector } from 'react-redux';
import Table from '@mui/material/Table';
import { LinearProgress, TableCell } from '@mui/material';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import axios from 'axios';

import {
  apiVideoFailedLibraryProvider,
  VideoManagerState
} from '../../store/videoManagerSlice';
import { OrganisationContext } from '../../App';
import { RootState } from '../../index';
import { EditVideoRequest } from '../modal/VideoEditRequest';
import { ChildVideo, VideoProps } from '../types/videos';
import { VideoBasicPreview } from '../modal/VideoBasicPreview';
import { TableCellHead, TableRow } from '../common/Table';
import { getApiBaseUrl } from '../../utils/env';
import PaginationTable from '../Pagination';
import removeButton from '../../icons/remove.png';

export default function VideoFailedTabContent() {
  const dispatch = useDispatch();
  const { selectedOrganisation } = useContext(OrganisationContext);
  const {
    failedVideos, busy, pagination: { totalItems, currentPage, itemsPerPage }
  } = useSelector<RootState, VideoManagerState>((state) => state.videoManager);
  const [editVideoRequest, setEditVideoRequest] = useState<ChildVideo>();
  const [previewVideo, setPreviewVideo] = useState<VideoProps>();

  const updateList = () => {
    dispatch(apiVideoFailedLibraryProvider({
      publisher: selectedOrganisation,
      limit: itemsPerPage,
      page: currentPage,
    }));
  };

  const removeLog = async (id: number) => {
    await axios.delete(`${getApiBaseUrl()}/video-log/${selectedOrganisation}/${id}`);
    updateList();
  };

  useEffect(() => {
    dispatch({ type: 'RESET_PAGINATION' });
    return () => {
      dispatch({ type: 'RESET_PAGINATION' });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!selectedOrganisation) return;

    updateList();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrganisation, itemsPerPage, currentPage]);

  return <>
    {previewVideo &&
      <VideoBasicPreview open={Boolean(previewVideo)} handleClose={() => setPreviewVideo(undefined)}
                         video={previewVideo}/>}
    {editVideoRequest && <EditVideoRequest open={Boolean(editVideoRequest)}
                                           handleClose={() => setEditVideoRequest(undefined)}
                                           video={editVideoRequest}/>}
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCellHead>Filename</TableCellHead>
          <TableCellHead>Inserted at</TableCellHead>
          <TableCellHead>Duration</TableCellHead>
          <TableCellHead sx={{ width: '30%' }}>Log</TableCellHead>
          <TableCellHead>Action</TableCellHead>
        </TableRow>
      </TableHead>
      <TableBody>
        {failedVideos.length === 0 &&
          <TableRow><TableCell colSpan={5}>No failed video</TableCell></TableRow>}
        {failedVideos.length > 0 && failedVideos.map(video => (
          <TableRow key={video.id}>
            <TableCell sx={{ wordBreak: 'break-word' }}>{video.filename}</TableCell>
            <TableCell><span style={{ whiteSpace: 'nowrap' }}><Moment
              format="DD/MM/YY HH:MM">{video.inserted_at}</Moment></span></TableCell>
            <TableCell>{video.ffprobe_metadata?.duration}</TableCell>
            <TableCell sx={{ width: '30%' }}>{video.logs}</TableCell>
            <TableCell sx={{ width: '10%' }}>
              <span onClick={async () => {
                if (window.confirm('Are you sure you want to delete this?')) {
                  await removeLog(video.id);
                }
              }} style={{ cursor: 'pointer' }}>
                <img width="28" src={removeButton} alt="remove button"/>
              </span>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
    {busy && <LinearProgress color="success"/>}
    <PaginationTable
      defaultSize={20}
      busy={busy}
      startPage={currentPage - 1}
      count={totalItems}
      onChange={page =>
        dispatch({
          type: 'SET_PAGINATION',
          payload: {
            currentPage: page + 1,
          },
        })
      }
      updateRowPerPage={totalPerPage => {
        dispatch({
          type: 'SET_PAGINATION',
          payload: {
            currentPage: 1,
            itemsPerPage: totalPerPage,
          },
        });
      }}
    />
  </>;
}